module.exports = __webpack_public_path__ + "img/1-md.b1ef9cbb.jpg";